import type { PILOT_MODULATORS_TABLE_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/pilot-modulators-table/pilot-modulators-table.fr.ts";

export const PILOT_MODULATORS_TABLE_ENGLISH_LOCALE = {
  globalSearchPlaceholder: "Search a value...",
  empty: "No modulators found...",
  headers: {
    serialNumber: "Serial number",
    acqRateInterpreted: "Acquisition rate",
    hwId: "Hardware Id",
    csId: "Cs Id",
    neuronId: "Neuron Id",
    localisation: "Location",
    siteId: "Site Id",
    typeKind: "Type",
  },
  filters: {
    placeholders: {
      serialNumber: "Search by serial number...",
      acqRateInterpreted: "Search by acquisition rate...",
      hwId: "Search by hardware Id...",
      csId: "Search by cs Id...",
      neuronId: "Search by neuron Id...",
      localisation: "Search by location...",
      siteId: "Search by site Id...",
      typeKind: "Search by type...",
    },
  },
} satisfies typeof PILOT_MODULATORS_TABLE_FRENCH_LOCALE;
